import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

const DashboardWinLossChart = ({ allGames }) => {
  const { monthly, cumRD } = useMemo(() => {
    if (!allGames?.length) return { monthly: [], cumRD: [] };
    const finished = allGames.filter(g => g.status?.abstractGameState === 'Final');
    const monthMap = {};
    let cumulative = 0;
    const rdArr = [];

    finished.forEach((g, i) => {
      const bosHome = g.teams?.home?.team?.id === 111;
      const bosScore = Number(bosHome ? g.teams.home.score : g.teams.away.score);
      const oppScore = Number(bosHome ? g.teams.away.score : g.teams.home.score);
      const won = bosScore > oppScore;
      const rd = bosScore - oppScore;
      cumulative += rd;
      rdArr.push([i + 1, cumulative]);

      const d = new Date(g.gameDate);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      const label = d.toLocaleDateString('en-US', { month: 'short' });
      if (!monthMap[key]) monthMap[key] = { label, wins: 0, losses: 0 };
      if (won) monthMap[key].wins++; else monthMap[key].losses++;
    });

    return { monthly: Object.values(monthMap), cumRD: rdArr };
  }, [allGames]);

  const monthlyOpt = {
    backgroundColor: 'transparent',
    grid: { top: 20, right: 16, bottom: 40, left: 44 },
    legend: { bottom: 0, textStyle: { color: '#a9c9b1', fontSize: 9 }, itemWidth: 10, itemHeight: 8 },
    tooltip: { trigger: 'axis', backgroundColor: '#1e3a29', borderColor: '#658d71', textStyle: { color: '#d8ceb3', fontSize: 10 } },
    xAxis: { type: 'category', data: monthly.map(m => m.label), axisLabel: { color: '#a9c9b1', fontSize: 9 }, axisLine: { lineStyle: { color: '#658d71' } } },
    yAxis: { type: 'value', minInterval: 1, axisLabel: { color: '#a9c9b1', fontSize: 9 }, axisLine: { lineStyle: { color: '#658d71' } }, splitLine: { lineStyle: { color: 'rgba(101,141,113,0.2)' } } },
    series: [
      { name: 'Wins', type: 'bar', data: monthly.map(m => m.wins), itemStyle: { color: 'rgba(169,201,177,0.85)', borderColor: '#a9c9b1', borderWidth: 1 }, stack: 'wl' },
      { name: 'Losses', type: 'bar', data: monthly.map(m => m.losses), itemStyle: { color: 'rgba(196,51,62,0.75)', borderColor: '#c4333e', borderWidth: 1 }, stack: 'wl' },
    ],
  };

  const rdOpt = {
    backgroundColor: 'transparent',
    grid: { top: 20, right: 16, bottom: 30, left: 50 },
    tooltip: { trigger: 'axis', backgroundColor: '#1e3a29', borderColor: '#658d71', textStyle: { color: '#d8ceb3', fontSize: 10 } },
    xAxis: { type: 'value', axisLabel: { show: false }, axisLine: { lineStyle: { color: '#658d71' } }, splitLine: { show: false } },
    yAxis: { type: 'value', axisLabel: { color: '#a9c9b1', fontSize: 9 }, axisLine: { lineStyle: { color: '#658d71' } }, splitLine: { lineStyle: { color: 'rgba(101,141,113,0.2)' } } },
    series: [{ type: 'line', data: cumRD, smooth: true, lineStyle: { color: '#d8ceb3', width: 2 }, areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(216,206,179,0.3)' }, { offset: 1, color: 'rgba(216,206,179,0.02)' }] } }, symbol: 'none' }],
  };

  if (!monthly.length) return null;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
        <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
          <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Monthly W/L</span>
        </div>
        <div className="p-2"><ReactECharts option={monthlyOpt} style={{ height: '160px' }} /></div>
      </div>
      <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
        <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
          <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Cumulative Run Differential</span>
        </div>
        <div className="p-2"><ReactECharts option={rdOpt} style={{ height: '160px' }} /></div>
      </div>
    </div>
  );
};

export default DashboardWinLossChart;